var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{ref:"lineComp",staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }